import gql from 'graphql-tag'

export const QUERY_GET_USERS = gql`
  query getPlatformUsers($page: Int, $pageSize: Int, $search: String) {
    getPlatformUsers(page: $page, pageSize: $pageSize, search: $search) {
      page
      records
      users {
        _id
        name
        email
        active
        emailConfirmed
        phone
        permissions {
          crm {
            accessSensitiveData
            accessSensitiveDataEmployees
            permissions
          }
          ecommerce {
            permissions
          }
        }
      }
    }
  }
`

export const QUERY_GET_USER = gql`
  query getPlatformUser($email: String!) {
    getPlatformUser(email: $email) {
      name
      email
      active
      phone
      permissions {
        storeAccess {
          ecommerce
          crm
        }
        stores {
          id
          accountId
          ecommerce
          club
        }
        ecommerce {
          roles
          permissions
        }
        crm {
          roles
          permissions
          accessSensitiveData
          accessSensitiveDataEmployees
        }
      }
      notificationConfigurations {
        availableIndustryCampaigns {
          whatsappBusinessAPI
          email
        }
      }
    }
  }
`

export const MUTATION_UPDATE_SELF_NOTIFICATION_CONFIGURATIONS = gql`
  mutation updateSelfPlatformUserNotificationConfiguration($notificationConfigurations: PlatformUserNotificationConfigurationsInput!) {
    updateSelfPlatformUserNotificationConfiguration(notificationConfigurations: $notificationConfigurations) {
      id
    }
  }
`

export const MUTATION_CREATE_USER = gql`
  mutation createPlatformUserAuth($permissionValue: PlatformUserPermissionsInput, $name: String!, $email: String!, $password: String!, $phone: String) {
    createPlatformUserAuth(permissions: $permissionValue, name: $name, email: $email, password: $password, phone: $phone) {
      id
    }
  }
`

export const MUTATION_UPDATE_USER = gql`
  mutation updatePlatformUserAuth(
    $permissionValue: PlatformUserPermissionsInput
    $name: String!
    $email: String!
    $newEmail: String
    $active: Boolean
    $password: String
    $phone: String
  ) {
    updatePlatformUserAuth(
      permissions: $permissionValue
      name: $name
      email: $email
      newEmail: $newEmail
      active: $active
      password: $password
      phone: $phone
    ) {
      id
    }
  }
`
